// msalInstance.js
import { PublicClientApplication } from '@azure/msal-browser';
// import { msalConfig, msalConfigProd } from '../msalConfig'; // Import your MSAL configuration
import config from 'utils/config';
import { msalConfig, msalConfigProd } from './msalConfig';

let configuration = config.envMsalAzureFlag ? msalConfigProd : msalConfig;

export const msalInstance = new PublicClientApplication(configuration);
